import { TranslatedCopy } from '../intl/TranslatedCopy';

import { SUCCESS_MESSAGE } from '../checkout/constants';
import { ORDER_TYPE_ATONCE, ORDER_TYPE_ATONCE_ALT, ORDER_TYPE_FUTURES, ORDER_TYPE_FORECAST } from '../shop/constants';

export const CART_STATUS_IDLE = 0;
export const CART_STATUS_FETCHING = 1;
export const CART_STATUS_VALIDATING = 2;
export const CART_STATUS_SUBMITTING = 3;

export const FIELD_NA = 'N/A';

export const ORDERTYPE_STRING_MAP = {
  Z011: new TranslatedCopy({ id: 'global.order.type.atonce' }).toString(),
  Z007: new TranslatedCopy({ id: 'global.order.type.atonce' }).toString(),
  Z008: new TranslatedCopy({ id: 'global.order.type.futures' }).toString(),
  Z010: new TranslatedCopy({ id: 'global.order.type.forecast' }).toString()
};

export const ORDERTYPE_TYPE_MAP = {
  Z007: ORDER_TYPE_ATONCE,
  Z011: ORDER_TYPE_ATONCE_ALT,
  Z008: ORDER_TYPE_FUTURES,
  Z010: ORDER_TYPE_FORECAST
};

export const ORDERTYPE_CODE_MAP = {
  [`${ORDER_TYPE_ATONCE}`]: 'Z007',
  [`${ORDER_TYPE_ATONCE_ALT}`]: 'Z011',
  [`${ORDER_TYPE_FUTURES}`]: 'Z008',
  [`${ORDER_TYPE_FORECAST}`]: 'Z010'
};

export const endpointSuccess = type => type && type.indexOf(SUCCESS_MESSAGE) !== -1;
